import * as React from 'react';
import IconProps from '@shared/icons/types/IconProps';

function SvgFiPaperclip({ size, color, ...props }: IconProps): React.JSX.Element {
	const finalSize = size !== undefined ? size : 16;
	const finalColor = color !== undefined ? color : 'currentColor';
	return (
		<svg
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 19 20"
			width={finalSize}
			height={finalSize}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.1502 1.98893C12.4867 1.98893 11.8504 2.25252 11.3812 2.72171L3.72283 10.38C2.94091 11.162 2.50163 12.2225 2.50163 13.3283C2.50163 14.4341 2.94091 15.4946 3.72283 16.2765C4.50475 17.0585 5.56527 17.4977 6.67107 17.4977C7.77688 17.4977 8.8374 17.0585 9.61932 16.2765L17.2777 8.6182C17.6031 8.29276 18.1307 8.29276 18.4562 8.6182C18.7816 8.94363 18.7816 9.47127 18.4562 9.79671L10.7978 17.455C9.70335 18.5495 8.21891 19.1644 6.67107 19.1644C5.12324 19.1644 3.6388 18.5495 2.54432 17.455C1.44984 16.3606 0.834961 14.8761 0.834961 13.3283C0.834961 11.7805 1.44984 10.296 2.54432 9.20153L10.2027 1.5432C10.9844 0.761448 12.0447 0.322266 13.1502 0.322266C14.2558 0.322266 15.3161 0.761447 16.0978 1.5432C16.8796 2.32495 17.3188 3.38523 17.3188 4.49079C17.3188 5.59635 16.8796 6.65663 16.0978 7.43837L8.43116 15.0967C7.96215 15.5657 7.32603 15.8292 6.66274 15.8292C5.99945 15.8292 5.36333 15.5657 4.89432 15.0967C4.4253 14.6277 4.16181 13.9916 4.16181 13.3283C4.16181 12.665 4.4253 12.0289 4.89432 11.5599L11.9697 4.49285C12.2953 4.1676 12.8229 4.16792 13.1482 4.49354C13.4734 4.81917 13.4731 5.34681 13.1475 5.67205L6.07283 12.7384C5.91659 12.8948 5.82848 13.1072 5.82848 13.3283C5.82848 13.5495 5.91638 13.7617 6.07283 13.9182C6.22929 14.0746 6.44148 14.1625 6.66274 14.1625C6.884 14.1625 7.0962 14.0746 7.25265 13.9182L14.9193 6.25986C15.3883 5.79071 15.6521 5.15417 15.6521 4.49079C15.6521 3.82725 15.3885 3.1909 14.9193 2.72171C14.4501 2.25252 13.8138 1.98893 13.1502 1.98893Z"
				fill={finalColor}
			/>
		</svg>
	);
}
export default SvgFiPaperclip;
